import { Text } from "theme-ui"

const Copyright = () => (
  <Text variant="xs" as="div" sx={{ color: "text.light" }}>
    &copy; {new Date().getFullYear()} Data-centric AI
  </Text>
)

export default Copyright
